import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {Subscription, take} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import { ModalService } from '../../services/modal/modal.service';
import { HelpersService } from '../../services/helpers.service';
import { ContractAvatarsService } from '../../modules/contracts/services/contract-avatar.service';
import { MemberModel } from '../../models/user.model';
import { FormControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { TFormState } from '../../models/forms.model';


@Component({
    selector: 'app-avatar-select-list',
    templateUrl: './avatar-list-select.component.html',
    styleUrls: ['./avatar-list-select.component.scss']
})
export class AvatarSelectListComponent  {
    @Input() users: MemberModel[]|undefined = undefined;
    public formTitle:string = '';
    public formState:TFormState = 'Default'
    @Output() eventAddUser: EventEmitter<{user:MemberModel,role:string}> = new EventEmitter();
    private usersFullList: MemberModel[] = [];
    public addedUsers:string[] = []
    public searchControl = new FormControl()
    private subs: Subscription = new Subscription();
    public rolesToSelcet = ['executor','responsible','observer']
    constructor(
        public modalService: ModalService,
        public helper: HelpersService,
        public translate: TranslateService,
        private contractAvatarsService: ContractAvatarsService,
        private cds: ChangeDetectorRef,
    ) {
    }
    ngOnDestroy(): void {
        this.subs.unsubscribe()
    }
    ngOnInit(): void {
        this.users?.forEach(el=>
            el.has_avatar === true? 
            this.contractAvatarsService.getAvatars([el.guid]).pipe(take(1)).subscribe(()=>this.cds.detectChanges()) : 
            this.contractAvatarsService.setGenericAvatar(el.guid,el).pipe(take(1)).subscribe())
        //this.contractAvatarsService.getAvatars(usersWithAvatars).subscribe(()=>this.cds.detectChanges())
       
        this.users? this.usersFullList = [...this.users] : null
        this.setSubscriptions()
        
    }
    setSubscriptions() {
        this.subs.add(this.contractAvatarsService.bSubAvatarsReady.asObservable().subscribe(()=>this.cds.detectChanges()))
        this.subs.add(this.searchControl.valueChanges.subscribe(val=>this.filterUserList(val)))
    }
    addUser(user:MemberModel, select:MatSelect) {
        this.formState = 'Submitting'
        this.eventAddUser.emit({user:user, role:select.value})
    }
    filterUserList(fil:string) {
        fil = fil?.toLocaleUpperCase()
        this.users = this.usersFullList.filter(el=>
            el.firstname?.toLocaleUpperCase().includes(fil)||
            el.lastname?.toLocaleUpperCase().includes(fil)||
            el.email?.toLocaleUpperCase().includes(fil)||
            el.project_setting.position?.toLocaleUpperCase().includes(fil)
        )
    }
}